export default {
  filesList(state) {
    return state.filesList;
  },
  status(state) {
    return state.status;
  },
  mailStatus(state) {
    return state.mailStatus;
  },
  respFileName(state) {
    return state.respFileName;
  }
}